import { Link } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";

/**
 * Shared layout for the content-heavy static pages (FAQ, HowTo, About,
 * VendorHandbook, TrustSafety, Changelog, Roadmap).
 *
 * Props:
 *   title    — big page heading
 *   subtitle — small mono kicker above the title
 *   intro    — optional paragraph under the title
 *   children — page body
 */
export default function DocPageLayout({ title, subtitle, intro, children }) {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-8 md:py-12 text-white">
      <Link
        to="/"
        data-testid="docpage-back"
        className="inline-flex items-center gap-1 font-mono text-[10px] tracking-widest uppercase text-zinc-500 hover:text-white"
      >
        <CaretLeft size={12} weight="bold" /> Home
      </Link>
      {subtitle && (
        <div className="mt-6 font-mono text-[11px] tracking-widest uppercase text-[#FF5F1F]">
          → {subtitle}
        </div>
      )}
      <h1 className="mt-2 font-display font-black uppercase text-4xl md:text-5xl tracking-tighter leading-none">
        {title}
      </h1>
      {intro && (
        <p className="mt-4 text-zinc-400 leading-relaxed text-[15px] max-w-2xl">
          {intro}
        </p>
      )}
      <div className="mt-10 space-y-10">{children}</div>
    </div>
  );
}

export function Section({ title, id, children }) {
  return (
    <section id={id} data-testid={id ? `section-${id}` : undefined} className="space-y-3">
      <h2 className="font-display font-black uppercase text-xl md:text-2xl tracking-tight border-b border-white/10 pb-2">
        {title}
      </h2>
      <div className="space-y-3 text-zinc-300 leading-relaxed text-[14px]">{children}</div>
    </section>
  );
}
